<ion-header collapse="fade">
  <ion-toolbar>
    <ion-title role="heading" aria-level="1" mode="md">
      {{ 'participation.title' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [scrollEvents]="true" class="ion-padding">
  <div class="app__content participation">
    <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
      <ion-refresher-content></ion-refresher-content>
    </ion-refresher>

    <div class="participation__dashboard">
      <div
        role="button"
        tabindex="0"
        [attr.aria-pressed]="filter === ParticipationItemType.RATING"
        [attr.aria-label]="('participation.open.rating' | translate) + ', ' + openCounts?.ratingCount + ' ' + ('participation.open' | translate)"
        (click)="toggleFilter(ParticipationItemType.RATING)"
        [class.selected]="filter === ParticipationItemType.RATING"
      >
        <div aria-hidden="true">
          <span *ngIf="openCounts?.ratingCount > 0"
            >{{ openCounts.ratingCount > 99 ? 99 : openCounts.ratingCount
            }}</span
          >
          <div
            class="inline-svg"
            inlineSVG="/assets/icons/participation/rating.svg"
          ></div>
        </div>
        <span>{{ 'participation.open.rating' | translate }}</span>
      </div>
      <div
        role="button"
        tabindex="0"
        [attr.aria-pressed]="filter === ParticipationItemType.SURVEY"
        [attr.aria-label]="('participation.open.survey' | translate) + ', ' + openCounts?.surveyCount + ' ' + ('participation.open' | translate)"
        (click)="toggleFilter(ParticipationItemType.SURVEY)"
        [class.selected]="filter === ParticipationItemType.SURVEY"
      >
        <div aria-hidden="true">
          <span *ngIf="openCounts?.surveyCount > 0"
            >{{ openCounts.surveyCount > 99 ? 99 : openCounts.surveyCount
            }}</span
          >
          <div
            class="inline-svg"
            inlineSVG="/assets/icons/participation/survey.svg"
          ></div>
        </div>
        <span>{{ 'participation.open.survey' | translate }}</span>
      </div>
      <div
        role="button"
        tabindex="0"
        [attr.aria-pressed]="filter === ParticipationItemType.POLL"
        [attr.aria-label]="('participation.open.poll' | translate) + ', ' + openCounts?.pollCount + ' ' + ('participation.open' | translate)"
        (click)="toggleFilter(ParticipationItemType.POLL)"
        [class.selected]="filter === ParticipationItemType.POLL"
      >
        <div aria-hidden="true">
          <span *ngIf="openCounts?.pollCount > 0"
            >{{ openCounts.pollCount > 99 ? 99 : openCounts?.pollCount }}</span
          >
          <div
            class="inline-svg"
            inlineSVG="/assets/icons/participation/poll.svg"
          ></div>
        </div>
        <span>{{ 'participation.open.poll' | translate }}</span>
      </div>
    </div>

    <ul class="participation__list" *ngIf="participationItems.length > 0">
      <li *ngFor="let item of participationItems">
        <app-card
          *ngIf="item.type === 'poll'"
          [type]="CardType.UPDATE"
          [language]="item.project.language"
          [project]="item.project"
          [dateAdded]="item.addedAt"
          [update]="item.pollUpdate"
          [withHeader]="true"
          [withFollowers]="false"
        ></app-card>
        <app-card
          *ngIf="item.type === 'survey'"
          [type]="CardType.SURVEY"
          [language]="item.project.language"
          [project]="item.project"
          [dateAdded]="item.addedAt"
          [survey]="item.survey"
          [withHeader]="true"
          [withFollowers]="false"
        ></app-card>
        <app-card
          *ngIf="item.type === 'rating'"
          [type]="CardType.RATING"
          [language]="item.project.language"
          [project]="item.project"
          [dateAdded]="item.addedAt"
          [withHeader]="true"
          [withFollowers]="false"
        ></app-card>
      </li>
    </ul>

    <ngx-skeleton-loader
      *ngIf="loading"
      appeareance="line"
      [theme]="{height: '20vh'}"
    ></ngx-skeleton-loader>

    @if (participationItems.length === 0 && !loading) { @if (feedbackCompleted)
    {
    <app-state-notice
      iconPath="/assets/illustrations/feedback_completed.svg"
      [title]="'participation.thank-you.title' | translate"
      [desc]="'participation.thank-you.desc' | translate"
    />
    } @else {
    <app-state-notice
      iconPath="/assets/illustrations/feedback_no_items.svg"
      [title]="'participation.empty.title' | translate"
      [desc]="'participation.empty.desc' | translate"
    />
    } }
  </div>
  <ion-infinite-scroll
    [hidden]="participationItems?.length == totalItems"
    (ionInfinite)="loadOpenItems($event)"
  >
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
